import { GetExcavationAndBuildingDurationResponseDto } from 'generated/apiSchemas';
import { parseDurationStringToMilliseconds } from 'technical/time-utils';

export const formatGraphDataWithDuration = (
  excavationBuildTimeGraphData: GetExcavationAndBuildingDurationResponseDto['graphData'],
) =>
  excavationBuildTimeGraphData.map(
    ({
      ringNumber,
      totalExcavationDuration,
      realExcavationDuration,
      totalBuildDuration,
      realBuildDuration,
    }) => {
      return {
        ringNumber: ringNumber,
        totalExcavationDuration: parseDurationStringToMilliseconds(
          totalExcavationDuration,
        ),
        realExcavationDuration: parseDurationStringToMilliseconds(
          realExcavationDuration,
        ),
        totalBuildDuration:
          parseDurationStringToMilliseconds(totalBuildDuration),
        realBuildDuration: parseDurationStringToMilliseconds(realBuildDuration),
      };
    },
  );
